// Public API for this module
import initParallax from "Modules/Animation/ParallaxManager";

// API
export default {
  initParallax: initParallax
} 